"use strict";

window.jQuery = window.$ = require("jquery");
window.mqRespond = require("./global/initmqRespond").mqRespondInit();
var processInclude = require("./util");

$(document).ready(function () {
    processInclude(require("./components/closestPolyfill"));
    processInclude(require("./global/focusevents").keyboardFocusOutline);
    processInclude(require("./components/menu"));
    processInclude(require("./components/cookie"));
    processInclude(require("./components/footer"));
    processInclude(require("./components/miniCart"));
    processInclude(require("./components/search"));
    processInclude(require("./components/countrySelector"));
    processInclude(require("./global/slickCarousel"));
    processInclude(require("./global/toggler"));
    processInclude(require("./components/immersiveVideo.js"));

    if ($(".m-product-launch").length == 0) {
        processInclude(require("./components/collapsibleItem"));
        processInclude(require("./components/toolTip"));
        processInclude(require("./components/clientSideValidation"));
    }

    if ($(".video-responser").length) {
        processInclude(require("./components/videoImage.js"));
        processInclude(require("./components/videoSoundControl.js"));
    }

    // page designer edit mode stop popups
    if ($(".js-pd-in-edit-mode").length === 0) {
        processInclude(require("./components/consentTracking"));

        if ($(".js-popin-btn").length) {
            processInclude(require("./components/showAssetPopup.js"));
        }

        if ($(".js-goodbye-message").length && $("#footercontent").length) {
            processInclude(require("./components/goodbyeMessagePopup.js"));
        }

        if ($(".js-newsletter-popin").length && $("#footercontent").length) {
            processInclude(require("./components/newsLetterPopup.js"));
        }
    } else {
        $("body").addClass("pd-in-edit-mode");
    }

    if ($(".c-newsletter").length) {
        processInclude(require("./components/handleNewsletterSection.js"));
    }

    if ($(".js-product-slider").length) {
        processInclude(require("./components/handleProductSlider.js"));
    }

    if ($(".order-thank-you-email").length) {
        processInclude(require("./components/handleLongEmail.js"));
    }

    if ($("#localesuggetion").length) {
        processInclude(require("./components/localeSuggestion"));
    }

    if ($(".c-form__clear-fields").length && window.mqRespond.status.lgDown) {
        processInclude(require("./components/clearInputField"));
    }

    processInclude(require("./countdownBanner"));
    processInclude(require("./components/bootstrapTooltipOverride"));

    if ($(".c-anniversary-secondary-banner").length) {
        processInclude(require("./components/anniversarySecondaryBanner"));
    }
});

require("./thirdParty/bootstrap");
require("./components/spinner");
require("./thirdParty/jquery-ui.min");
require("./thirdParty/picturefill.min.js");
require("./thirdParty/slick.min");
require("nodelist-foreach-polyfill");
require("es6-promise").polyfill();
require("./global/lazyLoading").manageLazyLoadingFeature();
require("./thirdParty/flipdown");
